import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'filename']
  connect() {}

  open() {
    this.inputTarget.click()
  }

  change() {
    this.filenameTarget.innerHTML = `
      <a href="#" class="cursor-pointer mr-1 text-body-text" data-action="click->input--button-file#remove:prevent:stop"><i class="fas fa-times-circle"></i></a>
      ${this.inputTarget.files[0].name}
    `
  }

  remove() {
    this.inputTarget.value = ''
    this.filenameTarget.innerHTML = ''
  }
}
